export const scrollToUp = () => {
  window.scrollTo(0, 0)
}
